import React from 'react';

import classes from './TupleBoxRight.scss';

const tupleBoxRight = (props) => <div className={`${classes.Box} u-flex f-column justify-content-between align-items-center pt-4 pb-3 pl-0 pr-0 u-phoneHide u-relative`}>{props.children}</div>;

export default tupleBoxRight;


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTuple/TupleBoxRight/TupleBoxRight.js